import Pagination from './Pagination';
import formatDateTimeUK from '@/helpers/formatDateTimeUK';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

import { getRequest } from '@/services/api';

import { useEffect, useState } from 'react';

const BloodRequests = ({ user }) => {
	const [bloodTestRequests, setBloodTestRequests] = useState(null);

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	useEffect(() => {
		const fetchBloodTestRequests = async () => {
			try {
				const fetchedTests = await getRequest(`/products/blood-test-requests/${user.customer_id}`);
				setBloodTestRequests(fetchedTests.data);
			} catch (error) {
				console.error('Error fetching blood tests:', error);
			}
		};
		fetchBloodTestRequests();
	}, []);

	if (!bloodTestRequests) {
		return (
			<Box sx={{ width: '100%' }}>
				<h2>Blood Test Requests</h2>
				<p>No available blood test requests</p>
			</Box>
		);
	}

	return (
		<Box sx={{ width: '100%' }}>
			<h2>Blood Test Requests</h2>
			<Paper sx={{ width: '100%', mb: 2 }}>
				<TableContainer style={{ overflowX: 'auto', width: '100%' }}>
					<Table className="table table-hover table-center mb-0" aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell sx={{ width: 40, padding: '0.25rem' }}>#</TableCell>
								{/* <TableCell sx={{ width: 150 }}>Appointment ID</TableCell> */}
								{/* <TableCell sx={{ width: 120 }}>Event ID</TableCell> */}
								{/* <TableCell sx={{ width: 120 }}>Location ID</TableCell> */}
								{/* <TableCell sx={{ width: 150 }}>Booking Entity ID</TableCell> */}
								<TableCell sx={{ width: 180, whiteSpace: 'nowrap' }}>Booking Name</TableCell>
								<TableCell sx={{ width: 220, overflow: 'hidden', textOverflow: 'ellipsis' }}>
									Booking Email
								</TableCell>
								<TableCell sx={{ width: 200 }}>Service Name</TableCell>
								<TableCell sx={{ width: 300 }}>Appointment Location</TableCell>
								<TableCell sx={{ width: 160 }}>Start Time</TableCell>
								<TableCell sx={{ width: 160 }}>End Time</TableCell>
								<TableCell sx={{ width: 100 }}>Duration</TableCell>
								<TableCell sx={{ width: 160 }}>NHS Number</TableCell>
								<TableCell sx={{ width: 100 }}>Doctor ID</TableCell>
								<TableCell sx={{ width: 140 }}>Scheduled By</TableCell>
								<TableCell sx={{ width: 100 }}>Status</TableCell>
								<TableCell sx={{ width: 120 }}>Other</TableCell>
								<TableCell sx={{ width: 140 }}>Location Category ID</TableCell>
								<TableCell sx={{ width: 140 }}>Clinician ID</TableCell>
								<TableCell sx={{ width: 180 }}>Markers</TableCell>
								<TableCell sx={{ width: 120 }}>Vial Type</TableCell>
								<TableCell sx={{ width: 180 }}>Phlebotomy Request ID</TableCell>
								<TableCell sx={{ width: 100 }}>Is Referred</TableCell>
								<TableCell sx={{ width: 160 }}>Referral Code</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{bloodTestRequests
								?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((appt, index) => (
									<TableRow key={index}>
										<TableCell>{index}</TableCell>
										{/* <TableCell>{appt.appointment_id}</TableCell> */}
										{/* <TableCell>{appt.event_id}</TableCell>
                                        <TableCell>{appt.location_id}</TableCell>
                                        <TableCell>{appt.booking_entity_id}</TableCell> */}
										<TableCell>{appt.booking_name}</TableCell>
										<TableCell>{appt.booking_email}</TableCell>
										<TableCell>{appt.service_name}</TableCell>
										<TableCell>{appt.appt_location}</TableCell>
										<TableCell>{formatDateTimeUK(appt.appt_start_dt)}</TableCell>
										<TableCell>{formatDateTimeUK(appt.appt_end_dt)}</TableCell>
										<TableCell>{appt.appointment_duration}</TableCell>
										<TableCell>{appt.nhs_number}</TableCell>
										<TableCell>{appt.doctor_id}</TableCell>
										<TableCell>{appt.scheduled_by}</TableCell>
										<TableCell>{appt.booking_status}</TableCell>
										<TableCell>{appt.other}</TableCell>
										<TableCell>{appt.location_category_id}</TableCell>
										<TableCell>{appt.clinician_id}</TableCell>
										<TableCell>{appt.additional_markers}</TableCell>
										<TableCell>{appt.vial_type}</TableCell>
										<TableCell>{appt.phlebotomy_request_id}</TableCell>
										<TableCell>{appt.is_referred ? 'Yes' : 'No'}</TableCell>
										<TableCell>{appt.referral_code}</TableCell>
									</TableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={bloodTestRequests?.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
		</Box>
	);
};

export default BloodRequests;
